import React, { useState } from 'react';
import { User, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import api from '../lib/api';
import { toast } from 'sonner';

const CompleteProfileModal = ({ user, onComplete }) => {
  const [form, setForm] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      toast.error('Name is required');
      return;
    }
    setSaving(true);
    try {
      const res = await api.completeProfile(form);
      toast.success('Profile completed!');
      onComplete(res.data);
    } catch (error) {
      toast.error('Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent className="bg-secondary-dark border-white/10 text-white max-w-md [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-electric-teal text-lg">Complete Your Profile</DialogTitle>
        </DialogHeader>
        <p className="text-white/50 text-sm">Please fill in your details to continue.</p>
        <div className="space-y-4 pt-2">
          <div>
            <Label className="text-white/60">Full Name *</Label>
            <div className="relative mt-1">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <Input
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="bg-primary-dark border-white/20 text-white pl-10"
                placeholder="Your full name"
                data-testid="profile-name-input"
              />
            </div>
          </div>
          <div>
            <Label className="text-white/60">Phone Number</Label>
            <div className="relative mt-1">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
              <Input
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="bg-primary-dark border-white/20 text-white pl-10"
                placeholder="778-555-1234"
                data-testid="profile-phone-input"
              />
            </div>
          </div>
          <Button
            onClick={handleSubmit}
            disabled={saving}
            className="w-full bg-electric-teal text-primary-dark font-bold"
            data-testid="profile-submit-btn"
          >
            {saving ? 'Saving...' : 'Continue'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CompleteProfileModal;
